module.exports = __webpack_public_path__ + "static/ai-99e5417a733d0e2a2a468c2766cebb36.jpg";